import { create } from 'zustand';

import { EResetStatus } from '@app/ForgotPassword/types';

export interface IResetStore {
	token: string | undefined;
	setToken: (newToken: string) => void;

	resetStatus: EResetStatus;
	setResetStatus: (newStatus: EResetStatus) => void;

	tokenMsg?: string | undefined;
	setTokenMsg: (newMsg: string) => void;
}

export const useResetStore = create<IResetStore>()((set) => ({
	token: undefined,
	setToken: (token: string) => set({ token }),

	resetStatus: EResetStatus.LOADING,
	setResetStatus: (status: EResetStatus) => set({ resetStatus: status }),

	tokenMsg: undefined,
	setTokenMsg: (msg: string) => set({ tokenMsg: msg }),
}));
